var _this = this;
import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SettingsService } from './settings.service';
import { RoutesService } from './routes.service';
import { ConfigurationsService } from './configurations.service';
import { ResourceService } from './resource.service';
import { UserService } from './user.service';
import { AuthenticationService } from './authentication.service';
import { LocalisationService } from './core/localisation.service';
import { TestService } from './test.service';
import { BreezeService } from './core/breeze.service';
import { AlertsService } from './core/alerts.service';
import { EntityManagerService } from './entity-manager.service';
import { BackendSettingsService } from './backend-settings.service';
import { ErrorService } from './core/error.service';
import { DomainService } from './domain.service';
var Bootflow = /** @class */ (function () {
    /**
    * Creates an instance of Bootflow.
    * @param {SettingsService} settingsService
    * @param {AuthenticationService} authenticationService
    * @param {UserService} userService
    * @param {ResourceService} resourceService
    * @param {ConfigurationsService} configurationsService
    * @param {RoutesService} routesService
    * @param {TestService} testService
    * @param {TranslateService} translateService
    * @param {LocalisationService} localisationService
    * @param {AlertsService} alertsService
    * @memberof Bootflow
    */
    function Bootflow(settingsService, authenticationService, entityManagerService, domainService, userService, resourceService, configurationsService, routesService, backendSettingsService, testService, translateService, localisationService, alertsService) {
        this.settingsService = settingsService;
        this.authenticationService = authenticationService;
        this.entityManagerService = entityManagerService;
        this.domainService = domainService;
        this.userService = userService;
        this.resourceService = resourceService;
        this.configurationsService = configurationsService;
        this.routesService = routesService;
        this.backendSettingsService = backendSettingsService;
        this.testService = testService;
        this.translateService = translateService;
        this.localisationService = localisationService;
        this.alertsService = alertsService;
    }
    Bootflow.prototype.bootProgess = function (message, percentage) {
        if (window['bootProgress']) {
            window['bootProgress'](message, percentage);
        }
    };
    Bootflow.prototype.start = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Start with this default
                        this.translateService.setDefaultLang('en-GB');
                        return [4 /*yield*/, this.settingsService.bootInit()];
                    case 1:
                        _a.sent();
                        this.bootProgess('Settings loaded', 30);
                        return [4 /*yield*/, this.authenticationService.bootInit()];
                    case 2:
                        _a.sent();
                        this.bootProgess('Authentication', 35);
                        return [4 /*yield*/, this.entityManagerService.bootInit()];
                    case 3:
                        _a.sent();
                        this.bootProgess('Entity manager loaded', 40);
                        return [4 /*yield*/, this.domainService.bootInit()];
                    case 4:
                        _a.sent();
                        this.bootProgess('Domain service started', 45);
                        return [4 /*yield*/, this.userService.bootInit()];
                    case 5:
                        _a.sent();
                        this.bootProgess('Current user is initiated', 50);
                        return [4 /*yield*/, this.resourceService.bootInit()];
                    case 6:
                        _a.sent();
                        this.bootProgess('Resource is loaded', 60);
                        return [4 /*yield*/, this.configurationsService.bootInit()];
                    case 7:
                        _a.sent();
                        this.bootProgess('Configuration is loaded', 70);
                        return [4 /*yield*/, this.routesService.bootInit()];
                    case 8:
                        _a.sent();
                        this.bootProgess('Routes are initiated', 80);
                        return [4 /*yield*/, this.backendSettingsService.bootInit()];
                    case 9:
                        _a.sent();
                        this.bootProgess('Backend preferences loaded', 90);
                        return [4 /*yield*/, this.testService.bootInit()];
                    case 10:
                        _a.sent();
                        this.bootProgess('Initial tests are finished', 100);
                        /* Adjust locale for different settings for NL-custom */
                        moment.defineLocale('nl-custom', {
                            parentLocale: 'nl',
                            relativeTime: {
                                future: 'over %s',
                                past: '%s geleden',
                                s: 'een paar seconden',
                                ss: 'een paar milliseconden',
                                m: '1 minuut',
                                mm: '%d minuten',
                                h: '1 uur',
                                hh: '%d uur',
                                d: '1 dag',
                                dd: '%d dagen',
                                M: '1 maand',
                                MM: '%d maanden',
                                y: '1 jaar',
                                yy: '%d jaar'
                            },
                            monthsShort: [
                                'Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun',
                                'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'
                            ],
                            weekdaysShort: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
                            weekdays: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag']
                        });
                        this.translateService.setDefaultLang(this.userService.language);
                        this.localisationService.setLanguage(this.userService.language);
                        BreezeService.adapterSetup(this.translateService, this.alertsService);
                        return [2 /*return*/];
                }
            });
        });
    };
    return Bootflow;
}());
export { Bootflow };
var ɵ0 = function (httpClient) {
    return new TranslateHttpLoader(httpClient, 'i18n/', '.bundle.json');
}, ɵ1 = function (bootflow, errorService) {
    return function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var error_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, bootflow.start()];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    if (error_1) {
                        errorService.addError(error_1);
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1 };
